export default "__VITE_ASSET__rhfQIbdQ__"